import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';

import AssociateConcernManagementPersonForm from '../../forms/AssociateConcernManagementPersonForm';

const { Column } = Table;

const AssociateConcernManagement = (props) => (
  <div>
    <h4>Management Team Details</h4>
    <Table dataSource={props.managementPersons} rowKey="id">
      <Column
        title="Name"
        key="name"
        render={(text, record) => {
          let entry = record;
          if (record.customer_management_person) entry = record.customer_management_person;
          return (<span>{`${entry.first_name} ${entry.middle_name} ${entry.last_name}`}</span>);
        }}
      />
      <Column
        title="Address"
        key="address"
        render={(text, record) => {
          let entry = record;
          if (record.customer_management_person) entry = record.customer_management_person;
          return (
            <span>
              {entry.street_address}
              <br />
              {entry.city}, {entry.state} - {entry.pincode}
            </span>
          );
        }}
      />
      <Column
        title="Networth"
        key="networth"
        render={(text, record) => {
          let entry = record;
          if (record.customer_management_person) entry = record.customer_management_person;
          return (<span>{entry.networth}</span>);
        }}
      />
    </Table>
    <br />
    <h5>Add new management team member</h5>
    <AssociateConcernManagementPersonForm customer_id={props.match.params.id} cac_id={props.match.params.cac_id} />
  </div>
);

AssociateConcernManagement.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      cac_id: PropTypes.string.isRequired,
    }),
  }).isRequired,
  managementPersons: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
};

export default AssociateConcernManagement;



// WEBPACK FOOTER //
// ./src/pages/factsheet/AssociateConcernManagement.jsx